(() => {
  const ROOT = '[data-product-detail-slide]';
  const instances = new WeakMap();

  function build(root) {
    if (instances.has(root)) return;
    if (typeof window.Swiper === 'undefined') return;

    const container = root.querySelector('.swiper');
    if (!container) return;

    const slideCount = container.querySelectorAll('.swiper-slide').length;
    if (slideCount === 0) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const paginationEl = root.querySelector('.swiper-pagination');
    const prevEl = root.querySelector('.product_detail_slide__nav-btn--prev');
    const nextEl = root.querySelector('.product_detail_slide__nav-btn--next');

    const swiper = new window.Swiper(container, {
      slidesPerView: 1,
      loop: false,
      speed: reduceMotion ? 0 : 400,
      a11y: { enabled: true },
      keyboard: { enabled: true, onlyInViewport: true },
      pagination: paginationEl ? { el: paginationEl, clickable: true } : false,
      navigation: prevEl && nextEl ? { prevEl, nextEl } : false,
    });

    instances.set(root, swiper);
  }

  function destroy(root) {
    const swiper = instances.get(root);
    if (!swiper) return;
    swiper.destroy(true, true);
    instances.delete(root);
  }

  function apply(scope = document) {
    scope.querySelectorAll(ROOT).forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => apply());
  } else {
    apply();
  }

  document.addEventListener('shopify:section:load', (event) => apply(event.target));

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(ROOT).forEach(destroy);
  });
})();
